import api, { setToken } from '../index';

export function response(data) {
	return api.post('/user/add/response', data.data, setToken(data.token));
}